import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.1156 16.1156C18.603 16.6281 17.772 16.6281 17.2594 16.1156L12.1875 11.0437L7.11558 16.1156C6.60301 16.6281 5.77199 16.6281 5.25942 16.1156C4.74686 15.603 4.74686 14.772 5.25942 14.2594L11.2594 8.25942C11.5056 8.01328 11.8394 7.875 12.1875 7.875C12.5356 7.875 12.8694 8.01328 13.1156 8.25942L19.1156 14.2594C19.6281 14.772 19.6281 15.603 19.1156 16.1156Z'
            />
        </SvgIcon>
    );
});
